// import './App.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container } from 'react-bootstrap';

import Chat from './pages/Chat';
import Register from './pages/Register';
import Login from './pages/Login';
import Home from './pages/Home';
import Error from './pages/Error';
import Profile from './pages/Profile';

import AppNavbar from './components/AppNavbar';


import { UserContext} from './contexts/UserContext'
import { ChatProvider } from './contexts/ChatContext';

function App() {
  const {user} = React.useContext (UserContext)
  
  return (
    
   <>

        <ChatProvider user={user}>
          <AppNavbar />
          <Container >
            <Routes>
              <Route path="/" element={user? <Chat /> : <Home />} />
              <Route path="/register" element={user? <Chat /> : <Register />} />
              <Route path="/login" element={user? <Chat /> : <Login />} />
              <Route path="/profile" element={user? <Profile /> : <Login />} />
              <Route path="*" element={<Error />} />
            </Routes>
          </Container >
        </ChatProvider>
   </>
    
    
  );
}

export default App;
